import { MaterialCommunityIcons } from '@expo/vector-icons';
import React from 'react';
import {StyleSheet, Text, Pressable} from "react-native";
import { useNavigate } from 'react-router-dom';

interface AccountCardProps {
    iconName: keyof typeof MaterialCommunityIcons.glyphMap;
    title: string;
    text: string;
    onPress?: () => void;
}

const AccountCard = ({iconName, title, text, onPress}: AccountCardProps) => {
    const navigate = useNavigate();

    const handlePress = () => {
        if (onPress) {
            onPress();
        } else {
            // Navigate based on title
            switch (title.toLowerCase()) {
                case 'personal info':
                case 'account info':
                case 'family info':
                case 'host info':
                    navigate('/account/personal-info');
                    break;
                case 'payments':
                    navigate('/account/payments');
                    break;
                case 'wishlists':
                    navigate('/favorites');
                    break;
                case 'profile':
                    navigate('/account/profile');
                    break;
                case 'settings':
                    navigate('/account/settings');
                    break;
                case 'notifications':
                    navigate('/account/notifications');
                    break;
                case 'favorites':
                    navigate('/account/favorites');
                    break;
                case 'sessions':
                    navigate('/account/sessions');
                    break;
                case 'locations':
                    navigate('/account/locations');
                    break;
                case 'payments':
                    navigate('/account/payments');
                    break;
                case 'privacy':
                    navigate('/account/privacy');
                    break;
                case 'help':
                    navigate('/account/help');
                    break;
                case 'logout':
                    navigate('/logout');
                    break;
                default:
                    navigate(`/account/${title.toLowerCase().replace(/\s+/g, '-')}`);
            }
        }
    };

    return (
        <Pressable style={styles.container} onPress={handlePress}>
            <MaterialCommunityIcons
                name={iconName}
                size={35}
                color='black'
            />
            <Text style={styles.title}>{title}</Text>
            <Text style={styles.text}>{text}</Text>
        </Pressable>
    )
};

export default AccountCard;

const styles = StyleSheet.create({
    container: {
        padding: 20,
        borderRadius: 10,
        backgroundColor: '#fff',
        shadowColor: 'black',
        shadowOffset: { width: 0, height: 3 },
        shadowOpacity: 0.1,
        shadowRadius: 10,
        elevation: 10,
        width: '30%',
        height: 180,
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
    },
    title: {
        fontWeight: '500',
        fontSize: 16,
        marginTop: 40,
    },
    text: {
        marginTop: 10,
        fontSize: 14,
        color: 'grey'
    }
})